/**
 * Billing step route (CLA-451) — eagerly registers the file route and its
 * `session_id` search validator; the step component, its atom/RPC imports, and
 * the Stripe.js bridge are deferred to `billing.lazy.tsx` so they load only with
 * this route, never in the always-loaded `main` chunk (CLA-645).
 *
 * @since 1.0.0
 */
import { createFileRoute } from "@tanstack/react-router";

/**
 * Narrow the route search into Stripe's post-payment `session_id`. Kept as a
 * plain function (not a Schema) so the validator is trivially unit-testable.
 *
 * @since 1.0.0
 */
export const validateBillingSearch = (
  search: Record<string, unknown>,
): { readonly sessionId?: string } => {
  const sessionId = search["session_id"];
  return typeof sessionId === "string" ? { sessionId } : {};
};

export const Route = createFileRoute("/clawinstall/onboarding/billing")({
  validateSearch: validateBillingSearch,
});
